export default "__VITE_PUBLIC_ASSET__50a24d89__"